import React from 'react';
import { PAGES } from '../seoPages';
import SeoPage from './SeoPage';

function Blog() {
  return <SeoPage page={PAGES.blog} />;
}

export default Blog;
